module.exports = __webpack_public_path__ + "img/vip_level_1.a91b1124.png";